import { AdditionalEvidenceRequest } from "./AdditionalEvidenceRequest";
import { Attachment } from "./Attachment";
import { Scope } from "./Scope";

type NullableString = string | null;

export enum ScopeApplicationState {
  Draft = 0,
  Submitted = 1,
  Complete = 2,
  Withdrawn = 3
}

export enum ScopeApplicationType {
  Expansion = 0
}

export type ScopeApplicationSummary = {
  id: string;
  type: ScopeApplicationType;
  createdBy: string;
  createdByName: string;
  createdAt: string;
  submittedBy?: string;
  submittedByName?: string;
  submittedAt?: string;
  updatedBy: string;
  updatedByName: string;
  updatedAt: string;
  organisationID: number;
  organisationName: string;
  state: ScopeApplicationState;
  title: NullableString;
  assignedToUpn?: string;
  assignedToDisplayName?: string;
  scopesCount: number;
}


export type ScopeApplication = ScopeApplicationSummary & {
  questionTwo: NullableString;
  questionThree: NullableString;
  questionFour: NullableString;
  questionFourAttachments: File[];
}

export const defaultValues: Partial<ScopeApplication> = {
  title: null,
  questionTwo: null,
  questionThree: null,
  questionFour: null,
}

export type ApplicationResponse = {
  item: ScopeApplication, 
  scopes: Scope[], 
  attachments: Attachment[], 
  evidenceRequests?: AdditionalEvidenceRequest[]
}